import React, { useContext, useState } from 'react';
import { ThemeContext } from '../../store/ThemeProvider';
import { getPendantColor } from '../../utils/color';
import ReactSVG from 'react-svg';
import { debounce } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

interface JigsawPendant {
  rootStore?: RootStore;
}

const JigsawPendant = (props: JigsawPendant) => {
  const { componentColor, backgroundColor, mainColor } = useContext(
    ThemeContext
  );
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);
  const [showLeft, setShowLeft] = useState(false);
  const toggle = debounce(function() {
    setShowLeft(prevState => !prevState);
  });
  const { wxuserStore } = props.rootStore!;

  const setJigsaw = function(type: string) {
    let { user } = wxuserStore;

    const activeGallery = activeGalleryInstance.get();
    activeGallery?.setJigsaw({
      type,
      bottomShow: true
    });
  };

  return (
    <div className="pendant-row">
      <div
        className="pendent-normal jigsaw-pendant"
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor
        }}
      >
        {showLeft ? (
          <div
            className={'left-show'}
            style={{ maxWidth: '100%', opacity: 1 }}
            onClick={toggle}
          >
            <div
              className={'one-item'}
              data-stat="P_Long"
              onClick={() => setJigsaw('long')}
            >
              {intl.get('Long Pic')}
            </div>
            <div
              className={'one-item'}
              data-stat="P_Poster"
              onClick={() => setJigsaw('poster')}
            >
              {intl.get('Poster')}
            </div>
            <ReactSVG
              src={require('../../svg/right-arrow.svg')}
              style={{
                fill: pendantIconColor,
                height: 15,
                width: 8,
                paddingLeft: 18
              }}
              className="icon"
            />
          </div>
        ) : (
          <div onClick={toggle}>{intl.get('Jigsaw')}</div>
        )}
      </div>
    </div>
  );
};
export default inject('rootStore')(observer(JigsawPendant));
